document.addEventListener("DOMContentLoaded", () => {

  const popup = document.querySelector(".video-popup");
  if (!popup) return;

  const popupVideo = popup.querySelector(".popup-left video");

  const productImage = popup.querySelector(".popup-product-image");
  const productTitle = popup.querySelector(".popup-product-title");
  const productPrice = popup.querySelector(".popup-product-price");
  const productDesc  = popup.querySelector(".popup-product-description");
  const productLink  = popup.querySelector(".product-link");

  const allVideos = document.querySelectorAll(".video-wrapper video");

  /* =========================
     🔥 CHROME AUTOPLAY FIX (REELS STYLE)
  ========================== */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

      const video = entry.target;

      // force Chrome autoplay rules
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");

      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }

    });
  }, { threshold: 0.6 });

  allVideos.forEach(video => {
    observer.observe(video);
  });

  /* =========================
     🎬 MANUAL PLAY BUTTON (AUTOPLAY OFF)
  ========================== */
  document.querySelectorAll(".video-wrapper").forEach(wrapper => {

    const video = wrapper.querySelector("video");
    const btn = wrapper.querySelector(".play-btn");

    if (!video) return;

    if (btn) {
      video.pause();

      btn.addEventListener("click", (e) => {
        e.stopPropagation();

        video.muted = true;
        video.play().catch(() => {});
        btn.style.display = "none";
      });

      video.addEventListener("pause", () => {
        btn.style.display = "block";
      });
    }

  });

  /* =========================
     📦 POPUP OPEN
  ========================== */
  document.addEventListener("click", (e) => {

    const card = e.target.closest(".video-card");
    if (!card) return;

    const videoEl = card.querySelector("video");
    const mp4 = videoEl?.dataset.mp4;

    if (!mp4) return;

    // pause background videos
    allVideos.forEach(v => v.pause());

    /* ===== VIDEO ===== */
    popupVideo.pause();
    popupVideo.src = mp4;

    // Chrome-safe setup
    popupVideo.muted = true;
    popupVideo.defaultMuted = true;
    popupVideo.setAttribute("muted", "");
    popupVideo.setAttribute("playsinline", "");

    popupVideo.controls = true;

    popupVideo.load();
    popupVideo.play().catch(() => {});

    /* ===== PRODUCT ===== */
    productImage.src = card.dataset.productImage || "";
    productTitle.textContent = card.dataset.productTitle || "";
    productPrice.textContent = card.dataset.productPrice || "";
    productDesc.textContent  = card.dataset.productDescription || "";
    productLink.href = card.dataset.productUrl || "#";

    popup.removeAttribute("hidden");

  });

  /* =========================
     ❌ CLOSE POPUP
  ========================== */
  popup.querySelector(".close-popup")?.addEventListener("click", () => {

    popup.setAttribute("hidden", true);

    popupVideo.pause();
    popupVideo.src = "";

    // resume visible videos
    allVideos.forEach(v => {
      v.play().catch(() => {});
    });

  });

});